import { BFF } from "services/network/routes"
import * as ActionTypes from "services/state/action-types"
import { dispatchHandler } from "services/utils/action"
import { get, post, put } from "../../network/endpoint"
import { saveOperation } from "../experience/action"

export function getInvoiceNegotiation() {
  return (dispatch) => {
    const config = { client: BFF }
    const request = get("invoiceNegotiation", config)
    dispatch({
      type: ActionTypes.GET_INVOICE_NEGOTIATION,
      payload: request
    })
  }
}

export function selectedInvoicesNegotiation(invoices) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_INVOICES_SELECTED_NEGOTIATION,
      payload: invoices
    })
  }
}

export function calculateNumberPlots(data) {
  return (dispatch) => {
    const config = { data, client: BFF }
    const request = post("calculateNumberPlots", config)
    dispatch({
      type: ActionTypes.GET_CALCULATE_NUMBER_PLOTS,
      payload: request
    })
  }
}

export function installments(data) {
  return (dispatch) => {
    const config = { data, client: BFF }
    const request = post("installments", config)
    dispatch({
      type: ActionTypes.GET_INSTALLMENTS,
      payload: request
    })
  }
}

function listeningPostMessage(done) {
  const eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent"
  const eventer = window[eventMethod]
  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message"

  // Listen to message from child window
  eventer(
    messageEvent,
    function (e) {
      if (
        e.origin === "https://algarpospago.stg.m4u.com.br" ||
        e.origin === "https://algarpospago.m4u.com.br"
      ) {
        done(e.data)
      }
    },
    false
  )
}

export function calcNegotiation(data) {
  return (dispatch, getState) => {
    const config = { data, client: BFF }
    const request = post("calcNegotiation", config)
    let requestId = null
    dispatch({
      type: ActionTypes.GET_CALC,
      payload: request
    }).then((action) => {
      if (action.type === ActionTypes.GET_CALC_FAIL) return
      requestId = action.payload.requestId
      const config2 = {
        pathValues: { requestId: action.payload.data.requestId },
        client: BFF
      }
      const request2 = get("statusCalc", config2)
      let executeExperience = false
      const getStatus = setInterval(() => {
        dispatch({
          type: ActionTypes.GET_STATUS_CALC,
          payload: request2
        }).then((action) => {
          if (action.type === ActionTypes.GET_STATUS_CALC_FAIL) {
            if (!executeExperience) {
              dispatch(
                saveOperation(
                  getState().customer.data,
                  "",
                  "NEGOTIATION",
                  "CALCULATE",
                  "ERROR",
                  "",
                  "Negociação de Conta"
                )
              )

              executeExperience = true
            }
            return
          }
          if (!executeExperience) {
            dispatch(
              saveOperation(
                getState().customer.data,
                "",
                "NEGOTIATION",
                "CALCULATE",
                "SUCCESS",
                "",
                "Negociação de Conta"
              )
            )

            executeExperience = true
          }
          if (
            action.payload.data.requestStatus === "Concluido" ||
            action.payload.data.requestStatus === "Aguardando"
          ) {
            clearInterval(getStatus)
            const request = get("resultCalc", config2)
            request.ID = requestId
            dispatch({
              type: ActionTypes.GET_RESULT_CALC,
              payload: request
            }).then((action) => {
              if (action.type === ActionTypes.GET_CALC_FAIL) return null
            })
          }
          if (
            action.payload.data.requestStatus === "Processamento parcial" ||
            action.payload.data.requestStatus === "Cancelada" ||
            action.payload.data.requestStatus === "Inconsistida"
          ) {
            clearInterval(getStatus)
            const request = get("resultCalc", config2)
            dispatch({
              type: ActionTypes.GET_RESULT_CALC,
              payload: request
            }).then((action) => {
              if (action.type === ActionTypes.GET_RESULT_CALC_FAIL) {
                dispatch({
                  type: ActionTypes.ERROR_CALC
                })
              }
            })
          }

          if (action.payload.data.requestStatus === "Inconsistida") {
            dispatch({
              type: ActionTypes.ERROR_CALC
            })
          }
        })
      }, 2000)
    })
  }
}

export function getDataModalPayment() {
  return (dispatch) => {
    // const data = { url: 'https://www.algar.com.br/AreaCliente/' }
    const data = { url: window.location.origin }
    const config = { data }
    const request = post("getUrlIframePayment", config)
    dispatch({
      type: ActionTypes.GET_URL_PAYMENT,
      payload: request
    }).then(function (response) {
      listeningPostMessage(function (response) {
        dispatch({
          type: ActionTypes.SAVE_CARD_DATA,
          payload: response
        })
      })
    })
  }
}

export function approve({ data, email }) {
  return (dispatch, getState) => {
    const state = getState()

    const updateDataPayload = {
      email,
      customerId: state.customer.data.customerId,
      income: state.customer.data.income
    }
    const config = { data: updateDataPayload, client: BFF }
    const request = put("updateEmailNegotiation", config)

    dispatch({
      type: ActionTypes.UPDATE_EMAIL,
      payload: request
    }).then(() => {
      const configApprove = { data, raw: true, client: BFF }
      const approveRequest = post("approvePayment", configApprove)
      dispatch({
        type: ActionTypes.APPROVE_PAYMENT,
        payload: approveRequest
      })
        .then((response) => {
          let protocol

          if (!!response && !!response.payload && !!response.payload.data) {
            protocol = response.payload.data.protocolNumber
          }

          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "NEGOTIATION",
              "SUBMIT",
              "SUCCESS",
              protocol,
              "Negociação de Conta"
            )
          )
        })
        .catch((response) => {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "NEGOTIATION",
              "SUBMIT",
              "ERROR",
              "",
              "Negociação de Conta"
            )
          )
        })
    })
  }
}

const updateEmailPromise = (
  dispatch,
  { installmentDueDate, requestId },
  callback,
  callbackFail
) => {
  const data = {
    data: {
      requestId,
      installmentDueDate,
      origin: "history"
    }
  }

  const emitBilletReq = post("emitBillet", data)

  dispatch({
    type: ActionTypes.EMIT_BILLET,
    payload: emitBilletReq
  }).then(dispatchHandler(callback, callbackFail))
}

export function updateEmailEmitBillet(
  { email, installmentDueDate, requestId },
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = { data: { mail: email } }
    const request = post("updateEmailNegotiation", config)

    dispatch({
      type: ActionTypes.UPDATE_EMAIL,
      payload: request
    }).then(() =>
      updateEmailPromise(
        dispatch,
        { installmentDueDate, requestId },
        callback,
        callbackFail
      )
    )
  }
}

export function closeEmitBilletModal() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.CLOSE_EMIT_FAIL_MODAL
    })
  }
}

export function setNegotiationParceling({ closeModal }) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_PARCELING,
      payload: closeModal
    })
  }
}

export function setParcelingData() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_PARCELING_DATA
    })
  }
}

export function orderNegotiationLogs() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.ORDER_NEGOTIATION_LOGS
    })
  }
}

export function getInvoiceLogs(paymentMethod = "boleto") {
  return (dispatch) => {
    const request = get("invoiceNegotiationLogs", {
      client: BFF,
      pathValues: { paymentMethod }
    })

    dispatch({
      type: ActionTypes.GET_NEGOTIATION_LOGS,
      payload: request
    })
  }
}

export function filterInvoiceLogs(paymentMethod = "boleto") {
  return (dispatch) => {
    const request = get("invoiceNegotiationLogs", {
      client: BFF,
      pathValues: { paymentMethod }
    })

    dispatch({
      type: ActionTypes.FILTER_NEGOTIATION_LOGS,
      payload: request
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/state/negotiation/action.js